export const YANDEX_METRIKA_ID = 112288057;

export const ANALYTICS_SOURCES = Object.freeze({
    WEB: 'web',
    TELEGRAM_MINIAPP: 'telegram_miniapp',
});

export const ANALYTICS_EVENTS = {
    ONBOARDING_REGISTRATION_STARTED: 'onboarding_registration_started',
    ONBOARDING_REGISTRATION_SUBMITTED: 'onboarding_registration_submitted',
    ONBOARDING_MEDIA_SUBMITTED: 'onboarding_media_submitted',
    ONBOARDING_LEGAL_SUBMITTED: 'onboarding_legal_submitted',
    ONBOARDING_PAYMENT_SUBMITTED: 'onboarding_payment_submitted',
    ONBOARDING_COMPLETED: 'onboarding_completed',
    ONBOARDING_DASHBOARD_OPENED: 'onboarding_dashboard_opened',
};

export const ONBOARDING_STEP_EVENTS = {
    photos: ANALYTICS_EVENTS.ONBOARDING_MEDIA_SUBMITTED,
    'legal-data': ANALYTICS_EVENTS.ONBOARDING_LEGAL_SUBMITTED,
    'payment-details': ANALYTICS_EVENTS.ONBOARDING_PAYMENT_SUBMITTED,
};
